/* global gtag */

import axios from 'axios';
// import Basket from '../modules/basket';
import NotifyLatch from '../modules/notify-latch';
import MobileMenu from '../modules/mobile-menu';
import Cookie from 'js-cookie';
import Sticky from 'sticky-js';

// import toastr from 'toastr';

export default {
  init() {

    new Sticky('.sticky');

    // var countdownTimer = false;

    // toastr.options = {
    //   'closeButton': true,
    //   'debug': false,
    //   'newestOnTop': true,
    //   'progressBar': true,
    //   'positionClass': 'toast-bottom-center',
    //   'preventDuplicates': true,
    //   'showDuration': '300',
    //   'hideDuration': '1000',
    //   'timeOut': 4000,
    //   'extendedTimeOut': 1000,
    //   'showEasing': 'swing',
    //   'hideEasing': 'linear',
    //   'showMethod': 'fadeIn',
    //   'hideMethod': 'fadeOut',
    // };

    // window.toastr = toastr;
    
    // function hook_notices() {
    //   jQuery('.woocommerce-message, .woocommerce-info').each(function(){
    //     var content = jQuery(this).text().replace('Undo?', '');
    //     jQuery(this).remove();
    //     toastr.info(content);
    //   });

    //   jQuery('.woocommerce-error').each(function(){
    //     var content = jQuery(this).text();
    //     jQuery(this).remove();
    //     toastr.error(content, '', {timeOut: 8000});
    //   });
    // }

    // Cover image links should be entirely clickable.

    jQuery('.wp-block-cover, .content .wp-block-cover.link-grid-box').each(function() {
      jQuery(this).css('cursor', 'pointer');
      if(jQuery(this).find('a').length > 0) {
        jQuery(this).on('click', () => {
          window.location = jQuery(this).find('a').first().attr('href');
        });
      }
    });

    // hook_notices();

    // $(document.body).on('updated_cart_totals', hook_notices);
    // $(document.body).on('wc_fragment_refreshed', hook_notices);
    // $(document.body).on('wc_update_cart', hook_notices);
    // $(document.body).on('updated_wc_div', hook_notices);

    // $(document.body).on('updated_wc_div', function() {
    //   Basket.update();
    // });

    // window.addToBasket = Basket.addToBasket;

    // window.hookAddToBasketButtons = function() {
    //   jQuery('.cart [name=add-to-cart]').off('click');
      // jQuery('.cart [name=add-to-cart]').on('click', function (e) {
      //   e.preventDefault();
      //   window.setFullPageLoader(true, 'Please Wait', 'Adding to your basket...');

      //   Basket.addToBasket(jQuery(this).attr('value'), jQuery(this).parent('form').find('.quantity input').first().val()).then((response) => {
      //     window.setFullPageLoader(false);
      //     if(response.data.error) {
      //       toastr.error(response.data.error_text);
      //     } else {
      //       toastr.info(response.data.title + ' added to your basket.');
      //     }

      //     Basket.update();

      //     gtag('event', 'add_to_cart', {
      //         'items': [
      //             {
      //                 id: response.data.id,
      //                 name: response.data.title,
      //                 quantity: response.data.quantity,
      //                 price: response.data.price,
      //                 variant: response.data.duty === 'DP' ? 'Duty Paid' : 'In Bond',
      //             },
      //         ],
      //     });          
      //   }).catch((e) => {
      //     console.log(e);
      //     location.reload(true);
      //   });
      // });
    // };

    // window.hookAddToBasketButtons();
    
    if(window.location.pathname.indexOf('/checkout') === -1 &&window.location.pathname.indexOf('/reauthenticate') === -1 && window.location.pathname.indexOf('/log-in') === -1 && window.location.pathname.indexOf('/checkout/order-pay') === -1) {
      Cookie.set('jbs_last', window.location.pathname);
    }

    // JavaScript to be fired on all pages
    $(document).ready(function() {
        $('body').tooltip({ selector: '[data-toggle=tooltip]' });
        MobileMenu.init();
    });

  //   jQuery('.btn-restore-basket').on('click', function(){
  //     if(confirm('Are you sure you want to restore this basket?')) {
  //         // Basket.restoreSavedBasket(jQuery(this).data('basket-id')).then(() => {
  //         //   location.reload();
  //         // }).catch(() => {
  //         //   window.setFullPageLoader(false);
  //         //   toastr.error('Sorry, there was an error restoring your basket. Please try again later.');
  //         // });
  //     }

  // });

  //   document.addEventListener('jb_basket_updated', function(e){

  //     if(!e.detail.active) {
  //       NotifyLatch.reset('jb_basket_expire_warning');
  //       NotifyLatch.reset('jb_basket_expire_soon');
  //     }

  //     jQuery('[data-jb-view=basket_total]').each(function(){
  //       jQuery(this).html(e.detail.basket_icon_display_total);
  //       if(e.detail.basket_count > 0) {
  //         jQuery(this).removeClass('d-none');
  //       } else {
  //         jQuery(this).addClass('d-none');
  //       }
  //     });

  //     jQuery('[data-jb-view=basket_count]').each(function(){
  //       jQuery(this).html(e.detail.basket_count);
  //     });

  //     jQuery('[data-jb-view=basket_expire]').each(function(){
  //       // if(Basket.state.active) {
  //       //   jQuery(this).removeClass('d-none');
  //       //   jQuery(this).html('Expires in ' + Math.floor((Basket.expires_at - (Date.now() / 1000)) / 60) + ' minutes');
  //       // } else {
  //       //   jQuery(this).addClass('d-none');
  //       //   jQuery(this).html('');
  //       // }
  //     });
  //   });

  //   document.addEventListener('jb_basket_expire_warning', function(){
  //     if(!NotifyLatch.has('jb_basket_expire_warning')) {
  //       jQuery('#modal-basket-expire-warning').modal('show');
  //       NotifyLatch.did('jb_basket_expire_warning')
  //     }
  //       // jQuery('[data-jb-view=basket_count]').parent('a').tooltip('show');

  //   });

  //   document.addEventListener('jb_basket_expire_soon', function(){
  //     if(!NotifyLatch.has('jb_basket_expire_soon')) {
  //       jQuery('#modal-basket-expire-soon').modal('show');
  //       NotifyLatch.did('jb_basket_expire_soon')
  //     }
  //     jQuery('[data-jb-view=basket_count]').parent('a').tooltip('show');
  //   });

  //   document.addEventListener('jb_basket_expired', function(){
    
  //     jQuery('#modal-basket-expired').modal('show');


  //     NotifyLatch.reset('jb_basket_expire_warning');
  //     NotifyLatch.reset('jb_basket_expire_soon');

  //     clearInterval(countdownTimer);
  //     countdownTimer = false;

  //     jQuery('[data-jb-view=basket_count]').parent('a').tooltip('hide');
  //     jQuery('[data-jb-view=basket_count]').parent('a').attr('data-original-title', '');

  //     // Basket.update();

  //     if(window.location.pathname.indexOf('/checkout') !== -1 || window.location.pathname.indexOf('/cart') !== -1 || window.location.pathname.indexOf('/basket') !== -1) {
  //       location.reload(true);
  //     }
  //   });

    document.addEventListener('jb_duty_changed', function(e){
      if(e.detail === 'IB') {
        if(!NotifyLatch.has('jb_ib_intro')) {
          jQuery('#modal-duty-ib-intro').modal('show');
          NotifyLatch.did('jb_ib_intro')
        }
      }
    });

    document.addEventListener('jb_breadcrumb_changed', function(e){
      if(e.detail) {
        jQuery('.woocommerce-breadcrumb').html('');
        for(var i in e.detail) {
          if(e.detail[i][1])
            jQuery('.woocommerce-breadcrumb').append(' / <a href="'+e.detail[i][1]+'">'+e.detail[i][0]+'</a>')
          else
            jQuery('.woocommerce-breadcrumb').append(' / '+e.detail[i][0])
        }
      }
    });

    document.addEventListener('jb_title_changed', function(e){
        jQuery('title').html(e.detail + ' - Jeroboams');
    });

    // Basket.load();
    // Basket.autoUpdate(true, 30);

    // var m = Math.floor((Basket.expires_at - (Date.now() / 1000)) / 60);

    // if(Basket.expires_at > 0 && Basket.state.active && m < 30 && m > 10 && m >= 0) {
    //   toastr.info('Your basket will expire in ' + m + ' minutes.');
    // }

    // if(Basket.state.active && countdownTimer === false) {

    //   var countdownToastEl = false;

    //   countdownTimer = setInterval(() => {
    //     var remaining = Basket.expires_at - (Date.now() / 1000);
    //     var t = Math.floor(remaining / 60);
    //     var s = Math.floor(remaining % 60);
    //     if(t <= 10 && t >= 0 && s >= 0) {

    //       if(countdownToastEl !== false) {
    //         countdownToastEl.remove();
    //         countdownToastEl = false;
    //       }

    //       countdownToastEl = toastr.info('Your basket will expire in ' + t + ':' + s.toString().padStart(2, '0'), '', {
    //         progressBar: false,
    //         timeOut: 0,
    //         extendedTimeOut: 0,
    //         closeButton: false,
    //         'showDuration': 0,
    //         'hideDuration': 0,
    //         'showEasing': 'swing',
    //         'hideEasing': 'linear',
    //         'showMethod': 'show',
    //         'hideMethod': 'hide',
    //         'closeMethod': 'hide',
    //         'tapToDismiss': false,
    //       }); 

    //     } else {
    //       if(countdownToastEl !== false) {
    //         countdownToastEl.remove();
    //         countdownToastEl = false;
    //       }
    //     }

    //   }, 1000);
    // }

    // if(!Basket.state.active && countdownTimer) {
    //   clearInterval(countdownTimer);
    //   countdownTimer = false;
    //   if(countdownToastEl !== false) {
    //     countdownToastEl.remove();
    //     countdownToastEl = false;
    //   }
    // }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    jQuery('[data-toggle=formats_collapse]').on('click', function(e){

      e.preventDefault();

      var text = jQuery(this).text();

      if(jQuery(this).hasClass('expanded')) {
        jQuery(this).text(text.replace('Hide', 'See'));
        jQuery(this).removeClass('expanded');
        jQuery(jQuery(this).attr('data-target')).removeClass('show');
      } else {
        jQuery(this).text(text.replace('See', 'Hide'));
        jQuery(this).addClass('expanded');
        jQuery(jQuery(this).attr('data-target')).addClass('show');
      }

    });

    jQuery('a.btn[data-toggle=collapse]').on('click', function(){
      var text = jQuery(this).text();
      if(text.toLowerCase().indexOf('more') !== -1) {
        jQuery(this).text(text.replace('more', 'less'));
        return;
      }

      if(text.toLowerCase().indexOf('less') !== -1) {
        jQuery(this).text(text.replace('less', 'more'));
        return;
      }

      if(text.toLowerCase().indexOf('show') !== -1) {
        jQuery(this).text(text.replace('show', 'hide'));
        return;
      }

      if(text.toLowerCase().indexOf('hide') !== -1) {
        jQuery(this).text(text.replace('hide', 'show'));
        return;
      }

    });

    const search_el = jQuery('.search-form-input');
    var timer = false;

    search_el.keyup(function(){

      if(jQuery(this).val().length < 3) {
        jQuery('.quick-links').removeClass('d-none');
        jQuery('.search-suggestions').html('');
      } else {
        jQuery('.quick-links').addClass('d-none');
      }

      if(jQuery(this).val().length < 3) {
        return;
      }

      if(timer) {
        clearTimeout(timer);
        timer = false;
      }

      var query_string = jQuery(this).val();

      timer = setTimeout(() => {

        gtag('event', 'search_suggestion', {
          'event_label': query_string,
          'event_category': 'engagement',
        });

        let duty_avail = null;

        if(jQuery('body').hasClass('current-duty-ib')) {
          duty_avail = 'IB';
        } else if (jQuery('body').hasClass('current-duty-dp')) {
          duty_avail = 'DP';
        }

        axios({
          method: 'get',
          url: window._D.jsonUrl + '/suggest',
          params: {
            q: query_string,
            d: duty_avail,
          },
        }).then(function (response) { 
            timer = false;
            if(response.status === 200) {
              jQuery('.search-suggestions').html('');

              if(response.data.suggestions.length > 0) {
                jQuery('.search-suggestions').append('<li class="separator">Suggestions</li>');
              }

              for(var i in response.data.suggestions) { 
                jQuery('.search-suggestions').append('<li class="suggestion"><a href="'+ response.data.suggestions[i].url + '"><span>'+response.data.suggestions[i].field+'</span>'+response.data.suggestions[i].text+'</a></li>');
              }

              if(response.data.products.length > 0) {
                jQuery('.search-suggestions').append('<li class="separator">Products</li>');
              }

              for(var j in response.data.products) {
                let duty_avail_message = '';
                switch(response.data.products[j].dutyavail) {
                    case 'DPOnly':
                      duty_avail_message = 'Duty Paid Only';
                      break;
                    case 'IBOnly':
                      duty_avail_message = 'In Bond Only';
                      break;  
                }
                jQuery('.search-suggestions').append('<li class="product"><a href="'+response.data.products[j].permalink +'"><span>'+response.data.products[j].text+'</span><span class="duty-avail">'+duty_avail_message+'</span></a></li>');
              }

              if(response.data.products.length > 0) {
                jQuery('.search-suggestions').append('<li class="search-more"><a href="/buy-wine/'+encodeURIComponent(query_string) +'">See more...</a></li>');
              }
            }
          
          });
      
      }, 300);
  
    });


      // Gets the video src from the data-src on each button
      var $imageSrc;  

      $('a[href$=".png"],a[href$=".jpg"],a[href$=".jpeg"]').click(function(e) {
          e.preventDefault();
          $imageSrc = $(this).attr('href');
          $('#lightbox-modal').modal('show');
      })
        
      $('#lightbox-modal').on('shown.bs.modal', function () {
        $('#lightbox-modal-image').attr('src', $imageSrc); 
      })
        
      $('#lightbox-modal').on('hide.bs.modal', function () {
          $('#lightbox-modal-image').attr('src',''); 
      }) 

      

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js